module.exports = __webpack_public_path__ + "img/bookmark.874b51fd.svg";